import { render } from "./ModalDocumentSanctionCheck.vue?vue&type=template&id=d2b5f226&scoped=true"
import script from "./ModalDocumentSanctionCheck.vue?vue&type=script&lang=js"
export * from "./ModalDocumentSanctionCheck.vue?vue&type=script&lang=js"

import "./ModalDocumentSanctionCheck.vue?vue&type=style&index=0&id=d2b5f226&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b5f226"]])

export default __exports__